<div class="position-relative ml-1" aria-labelledby="add-more">
  <div class="row add-more__option position-absolute" id="append-left-margin">
    <div class="col-11 pl-0 pr-2">
      <div class="position-relative">
        <div class="col p-0" [ngClass]="toggle===true?'auto-complete__opened':''" style="max-height: 198px">
          <div id="workflowRole" class="custom-select font-bold" [ngClass]="toggle===true?'opened':''"
            (click)="openPanel($event,toggle = (toggle === false ? true :false),null)"
            *ngIf="selectedArrayObj.length === 0" id="search-panel">

            <label for="metadataSetDropdown" class="font-bold">
              <ng-container *ngIf="!getValueList">Search Key</ng-container>
              <ng-container *ngIf="getValueList">Search for value</ng-container>
            </label>

          </div>

          <div id="workflowRole" class="custom-select font-bold auto-complete__choice-holder"
            *ngIf="selectedArrayObj.length > 0"
            (click)="openPanel($event,toggle = (toggle === false ? true :false),null)">
            <div class="w-100 d-inline-flex align-items-center">
              <div class="col-auto p-1 d-inline-flex align-items-center auto-complete__choice-tag"
                *ngFor="let option of selectedArrayObj">
                <span class="text-truncate d-inline-block tag">{{option.name ||option.label | titlecase}}</span>
                <button type="button" (click)="deleteObj(option,$event);openPanel($event,toggle =true,'delete')"
                  id="deleteSelectedElement" attr.aria-label="remove {{option.name ||option.label}}"
                  class="auto-complete__choice-tag__remove btn-icon">x</button>
              </div>
            </div>
          </div>

          <div class="auto-complete__list advDropDown" id="auto-complete__list_adv" style="display: none; max-height: 238px">
            <div class="auto-complete__search position-relative">
              <input (click)="openPanel($event,toggle =true,'delete')" id="metadataSetDropdown" type="search"
                class="form-control font-bold" (keyup)="searchItems()" [(ngModel)]="search">
            </div>

            <ul class="list-unstyled auto-complete__list__items mb-0 px-0" aria-labelledby="metadataSetDropdown">
              <ng-container *ngIf="!getValueList">
                <li *ngFor="let data of searchListReult" class="options">
                  <button type="button" [class.no-record]="data['name']==='No Record Found'"
                    [ngClass]="data.is_selected===1?'selected':''" (click)="selectObject(data);"
                    class="options-item cursor-pointer text-left">
                    {{data.name | titlecase}}
                  </button>
                </li>
              </ng-container>
              <ng-container *ngIf="inputForFilter && inputForFilter.length>0 && getValueList">
                <li id="" *ngFor="let data of (search.length > 0 ? filteredResult : inputForFilter)" class="options">
                  <button type="button" [class.no-record]="data['label']==='No Record Found'"
                    [ngClass]="data.is_selected===1?'selected':''" (click)="selectObject(data);"
                    class="options-item cursor-pointer text-left">
                    {{data.label}}
                  </button>
                </li>
              </ng-container>

            </ul>
          </div>

          <div class="col-12 p-1 border value-container" *ngIf="getValueList">
            <div class="col-auto p-1 d-inline-flex align-items-center auto-complete__choice-tag"
              *ngIf="selectedFilterKeyObj">
              <span class="text-truncate d-inline-block tag">{{selectedFilterKeyObj['name'] | titlecase}}</span>
              <button type="button"
                (click)="deleteObj(selectedFilterKeyObj,$event);openPanel($event,toggle =true,'delete')"
                id="deleteSelectedElement1" attr.aria-label="remove {{selectedFilterKeyObj['name']}}"
                class="auto-complete__choice-tag__remove btn-icon">x</button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="col-1 pl-0">
      <button id = "addAdv" class="btn btn-primary" (click)="addObj();" aria-label="Add" [disabled]="!valid">+</button>
    </div>
  </div>
</div>